import { Pipe, PipeTransform, inject } from '@angular/core';
import { GridFormatService } from "../services";

@Pipe({ name: "gridCurrency" })
export class GridCurrencyPipe implements PipeTransform
{
    private $gridFormatService = inject(GridFormatService);


    transform(value: any, column: any): any
    {
        return this.$gridFormatService.currencyFormatter(value, column);
    }
}
